import spm from './client';
const opts = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};
const enhancedOpts = {
    headers: {
        Accept: 'application/vnd.synchronoss.spm.user.feature-1.0+json',
    },
};
const apiType = 'spm';
export const getTaggingEnrollment = async (headers, logger) => {
    logger ? spm.setLogger(logger) : undefined;
    return spm.get('/{userId}/tagging/enrollment', apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
export const deleteTaggingEnrollment = async (headers, logger) => {
    logger ? spm.setLogger(logger) : undefined;
    return spm.delete('/{userId}/tagging/enrollment', apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
export const postTaggingEnrollment = async (headers, force, logger) => {
    logger ? spm.setLogger(logger) : undefined;
    return spm.post(`/{userId}/tagging/enrollment?force=${force}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
export const postTaggingEligibility = async (headers, logger) => {
    logger ? spm.setLogger(logger) : undefined;
    return spm.post('/{userId}/tagging/eligibility', apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
export const getEnhancedPlans = async (headers, logger) => {
    logger ? spm.setLogger(logger) : undefined;
    return spm.get('/user/{userId}/features?expanded=true', apiType, {
        headers: { ...opts.headers, ...enhancedOpts.headers, ...headers },
    });
};
